import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const PremiumContext = createContext(null);

export const PremiumProvider = ({ children }) => {
  const { api, user } = useAuth();
  const [isPremium, setIsPremium] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPremiumStatus = useCallback(async () => {
    if (!user) {
      setIsPremium(false);
      setSubscriptionPlan(null);
      setLoading(false);
      return;
    }

    try {
      const res = await api().get('/subscriptions/status');
      setIsPremium(res.data.is_subscribed);
      if (res.data.subscription?.plan_id) {
        setSubscriptionPlan(res.data.subscription.plan_id);
      }
    } catch (err) {
      setIsPremium(false);
    }
    setLoading(false);
  }, [api, user]);

  useEffect(() => {
    fetchPremiumStatus();
  }, [fetchPremiumStatus]);

  const refreshPremiumStatus = () => {
    setLoading(true);
    fetchPremiumStatus();
  };

  return (
    <PremiumContext.Provider value={{ 
      isPremium, 
      subscriptionPlan, 
      loading,
      refreshPremiumStatus 
    }}>
      {children}
    </PremiumContext.Provider>
  );
};

export const usePremium = () => {
  const context = useContext(PremiumContext);
  if (!context) {
    throw new Error('usePremium must be used within a PremiumProvider');
  }
  return context;
};

export default PremiumContext;
